document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('.nav-top-common');
  const showButton = document.querySelector('.nav-top-show');

  const primaryLinks = Array.from(document.querySelectorAll('.nav-top-primary > li > a'))

  showButton.addEventListener('click', () => {
    const isExpanded = nav.classList.toggle('active');
    showButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    showButton.setAttribute('aria-label', isExpanded ? 'Close navigation menu' : 'Open navigation menu');
  });

  primaryLinks.forEach(link => {
    const secodaryList = link.nextElementSibling;
    const hasSecondaryList = secodaryList && secodaryList.classList.contains('nav-top-secondary');
    if (!hasSecondaryList) return;

    link.parentElement.addEventListener('mouseover', () => {
      link.dataset.overAt = Date.now();
    });

    link.parentElement.addEventListener('mouseenter', () => {
      link.setAttribute('aria-expanded', 'true');
    });

    link.parentElement.addEventListener('mouseleave', () => {
      link.setAttribute('aria-expanded', 'false');
    });

    link.addEventListener('click', event => {
      const isMobile = window.matchMedia('(max-width: 900px)').matches;
      if (isMobile) return;

      // Don't follow the link if it's tapped when the list is just opened. This
      // is required for touch interfaces which handle `mouseover` and `click`
      // together, therefore not allowing to view and select items on the
      // secondary list.
      if (link.dataset.overAt && Date.now() - link.dataset.overAt < 100)
        event.preventDefault();
    });
  });

  nav.towerLastScrollPosition = 0;
  nav.towerScrollOffset = 0;
  document.addEventListener('scroll', () => {
    const isOnMobile = window.matchMedia('(max-width: 900px)').matches;
    if (isOnMobile) return;

    // Always show nav when near the top of the page (within 30px)
    if (window.scrollY <= 30) {
      nav.towerScrollOffset = 0;
      nav.style.top = '0px';
      nav.style.transition = 'top 0.2s';
      nav.towerLastScrollPosition = window.scrollY;
      return;
    }

    const paralaxFactor = 0.8;
    const style = window.getComputedStyle(nav);
    const shadow = 20; // The size of the navigation pill's shadow
    const limit = (parseFloat(style.height) + parseFloat(style.marginTop) + shadow) / paralaxFactor;
    const scrollThreshold = 70; // Only show nav after scrolling up this many pixels

    const diff = nav.towerLastScrollPosition - window.scrollY;
    if (diff < 0 && window.scrollY > 0) {
      // Scrolling down - hide nav
      const offset = Math.max(-limit, Math.min(0, nav.towerScrollOffset + diff));
      nav.towerScrollOffset = offset;
      nav.style.top = `${Math.round(offset * paralaxFactor)}px`;
      nav.style.transition = 'none';
    } else if (diff > scrollThreshold) {
      // Scrolling up past threshold - show nav
      nav.towerScrollOffset = 0;
      nav.style.top = '0px';
      nav.style.transition = 'top 0.2s';
    }
    // If scrolling up but not past threshold, keep nav in current position

    nav.towerLastScrollPosition = window.scrollY;
  });

  nav.addEventListener('mouseover', () => {
    nav.towerScrollOffset = 0;
    nav.style.top = '0px';
    nav.style.transition = 'top 0.2s';
  });

  // Set order of primary items so that they can be reordered on mobile
  const primaryItems = Array.from(document.querySelectorAll('.nav-top-primary > li'));
  primaryItems.forEach((item, index) => {
    item.style.order = index;
  });
});
